import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import CostTypeForm from './costTypeForm'
import List from '../List'

const MerchandiseCostType = (props) => {
  //   const dispatch = useDispatch()
  //   const [isAddingDuty, setIsAddingDuty] = useState(false)

  const { merchandiseId, isFormDisabled, translate, invoiceId, updateData, deleteData } = props

  const costTypeList = useSelector((state) => {
    return state.ValueBuildUpReducer.shipmentInvoice
      .find((c) => c.invoiceId === invoiceId)
      ?.merchandise?.find((a) => a.merchandiseId === merchandiseId)?.merchandiseCostType
  })
  // const updateData = useCallback((CostTypeId, payload) => {
  //   // dispatch(updateCostType(CostTypeId, payload))
  // }, [])

  // const deleteData = useCallback((CostTypeId, updateRemovingStatus) => {
  //   // dispatch(deleteCostType(CostTypeId, updateRemovingStatus))
  // }, [])
  const renderItem = useCallback(
    (item) => {
      return (
        <CostTypeForm
          isMerchandised={true}
          key={item.euroValue}
          item={item}
          isFormDisabled={isFormDisabled}
          updateData={updateData}
          deleteData={deleteData}
          translate={translate}
        />
      )
    },
    [isFormDisabled, updateData, deleteData, costTypeList?.length, translate]
  )

  return (
    <Form.Group className='float-container mg-t-15' widths='equal'>
      <div
        style={{
          textTransform: 'uppercase',
          marginTop: '-5px',
          display: 'flex',
        }}
      >
        <div>
          <strong>{translate('LINE_ITEM_VALUES', { ns: ['default', 'lineItem'] })}</strong>
        </div>
      </div>

      <List renderItem={renderItem} dataSource={costTypeList} />
    </Form.Group>
  )
}

export default React.memo(MerchandiseCostType)
